// import {
// 	stores as leadFunnelStores,
// 	styles as leadFunnelStyles,
// } from "@components/Main/Shared/LeadFunnel/.config";

import leadFunnelModalStore from "@components/Main/Shared/LeadFunnel/@stores/LeadFunnelModal.store.js";

// import {
// 	stores as searchPanelStores,
// 	styles as searchPanelStyles,
// } from "@components/Main/Shared/SearchPanel/.config";

// import {
// 	stores as proListStores,
// 	styles as proListStyles,
// } from "@custom/ProList/.config";

// import {
// 	stores as quickPickQuestionStores,
// 	styles as quickPickStyles,
// } from "@components/Main/Shared/QuickPickQuestion/.config";

export default {
	stores: {
		leadFunnelModalStore,
		//...leadFunnelStores,
		// ...proListStores,
		// ...searchPanelStores,
		// ...quickPickQuestionStores,
	},
	styles: {
		// ...proListStyles,
		// //...leadFunnelStyles,
		// ...searchPanelStyles,
		// ...quickPickStyles,
	},
};
